import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectAvailableActualsTypes = createSelector(
  [selectConfigurationState],
  (state) => state.availableActualsTypes
)
